import { IonImg, IonText } from '@ionic/react';
import { Capacitor } from '@capacitor/core';
import classNames from 'classnames';

import classes from './EuCofundingNotice.module.scss';
import textClasses from 'src/styles/text.module.scss';
import euCofundedLogo from 'src/assets/img/eu-cofunded-est.png';

// PK-251 EIS publicity requirement: color logo + description, aim, result and amount. Web only, Estonian in all languages.
const EuCofundingNotice: React.FC = () => {
  if (Capacitor.isNativePlatform()) {
    return null;
  }

  return (
    <div className={classes.notice}>
      <IonImg src={euCofundedLogo} alt="Kaasrahastanud Euroopa Liit. Eesti tuleviku heaks." className={classes.logo} />
      <IonText color="medium">
        <p className={classNames(textClasses.textS, classes.text)} lang="et">
          Digitaliseerimise teekaart koostati ajavahemikus 13.05.2026 – 13.08.2026. Digitaliseerimise teekaardi
          eesmärgiks on, läbi ettevõtte seniste tegevuste ja protsesside analüüsi ning ettevõtte plaanide, töötada välja
          võimalused tööprotsesside omavaheliseks integreerimiseks ning kitsaskohtade kõrvaldamiseks. Projekti
          tulemusena valmis edukalt ettevõtte digitaliseerimise teekaart. Digitaliseerimise teekaardi koostamist
          kaasrahastas Euroopa Liit summas 10&nbsp;000,00 eurot.
        </p>
      </IonText>
    </div>
  );
};

export default EuCofundingNotice;
